// extracted by mini-css-extract-plugin
export default {"textContainer":"iotCaseStudy_textContainer__OZ5aP","overlay":"iotCaseStudy_overlay__ls35r","heading":"iotCaseStudy_heading__9f9nP"};